"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
var _state = require("./state");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = function _default() {
  if (_state.state._config.sendPreservedToRemote) {
    _mttPostal.default.iterateOverQueue(function (envelope) {
      if (_mttPostal.default.fedx.canSendRemote(envelope.channel, envelope.topic)) {
        _mttPostal.default.fedx.sendMessage(envelope);
      }
    });
  }
};
exports.default = _default;